import { Injectable } from '@angular/core'
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { of } from 'rxjs'
import {
  CmsActivatedRouteSnapshot,
  CmsService,
  Page,
  ProtectedRoutesGuard,
  RouteLoadStrategy,
  RoutingConfigService,
  RoutingService,
  WindowRef
} from '@spartacus/core'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { DateAndTimeUtils } from '../../shared/utils/date-and-time-utils'
import { CmsPageGuard, CmsPageGuardService } from '@spartacus/storefront'
import { MbProductConnector } from '../../product/connectors'

@Injectable({
  providedIn: 'root'
})
export class CmsPageHiddenGuard extends CmsPageGuard implements CanActivate {

  notFound = this.router.parseUrl('/not-found')

  constructor (cmsService: CmsService,
               private router: Router,
               routingService: RoutingService,
               protectedRoutesGuard: ProtectedRoutesGuard,
               private cmsPageGuardService: CmsPageGuardService,
               routingConfigService: RoutingConfigService,
               private productDetailByCodeConnector: MbProductConnector,
               protected winRef: WindowRef) {
    super(routingService, cmsService, protectedRoutesGuard, cmsPageGuardService, routingConfigService)
  }

  canActivate (route: CmsActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const { url } = route
    // short url
    if (url?.length === 1 && url?.[0]?.path?.match('^[0-9]{3}-([0-9]{2}|[0-9]{3}-[0-9]{3})$')) {
      const productCode = url[0].path
      return this.productDetailByCodeConnector.getDetailByCode(productCode).pipe(
        map(product => product.url && product.originalCode === productCode
          && this.router.parseUrl(product.url?.toLowerCase()) || this.notFound),
        catchError(() => of(this.notFound))
      )
    }

    return this.routingService.getNextPageContext().pipe(
      filter(pageContext => !!pageContext),
      switchMap(pageContext => !!pageContext ?
        this.cmsService.getPage(pageContext, this.routingConfig.getLoadStrategy() !== RouteLoadStrategy.ONCE).pipe(
        map(page => page && this.isPageVisible(page) ? true : this.notFound))
        : of(false)
      )
    )
  }

  isPageVisible (page?: Page) {
    if (this.isInIframe()) {
      return true
    }
    const hidePage = page?.properties?.formData?.pt_hidePage?.value?.identifier === 'true' ?? false
    const hideAfter = page?.properties?.formData?.st_hide_after_date?.value ?? ''
    const hideBefore = page?.properties?.formData?.st_hide_before_date?.value ?? ''
    return !hidePage && DateAndTimeUtils.isCurrentDateBetween(hideBefore, hideAfter)
  }

  /**
   * Checks if the current page is in an iFrame to identify if currently in FS Content Creator
   */
  isInIframe () {
    return this.winRef.nativeWindow?.self !== this.winRef.nativeWindow?.top
  }
}
